module.exports = __webpack_public_path__ + "01_short_brown.c46aef13.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/01_short_brown.png
// module id = v9dM
// module chunks = 0